import { useEffect, useRef } from "react";
import { X } from "lucide-react";
import { Logo } from "@/components/ui/Logo";
import styles from "./ReminderToast.module.css";

const VISIBLE_MS = 12_000;

/**
 * Hora ruim pra interromper com um lembrete: aba em segundo plano (ninguém vai ver) ou com um
 * formulário/modal aberto (a notificação atrapalharia o que a pessoa está fazendo).
 */
export function isBadMomentForReminder() {
  return document.hidden || !!document.querySelector("[role=dialog], [role=alertdialog]");
}

interface ReminderToastProps {
  message: string;
  actionLabel: string;
  onAction: () => void;
  onClose: () => void;
}

/** Lembrete com cara de notificação de celular. Some sozinho depois de alguns segundos. */
export function ReminderToast({ message, actionLabel, onAction, onClose }: ReminderToastProps) {
  const closeRef = useRef(onClose);
  closeRef.current = onClose;

  useEffect(() => {
    const timer = window.setTimeout(() => closeRef.current(), VISIBLE_MS);
    return () => window.clearTimeout(timer);
  }, [message]);

  return (
    <div className={styles.toast} role="status" aria-live="polite">
      <span className={styles.appIcon}>
        <Logo size={34} />
      </span>
      <div className={styles.body}>
        <p className={styles.meta}>
          <strong>ControleNext</strong> · agora
        </p>
        <p className={styles.text}>{message}</p>
        <button type="button" className={styles.cta} onClick={onAction}>
          {actionLabel}
        </button>
      </div>
      <button type="button" className={styles.close} onClick={onClose} aria-label="Fechar lembrete">
        <X size={15} strokeWidth={2.4} />
      </button>
    </div>
  );
}
